package com.dwarshb.bms

import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable

data class BusSeat(val id: String, val seatType: String,val isBooked: Boolean = false)

@Serializable
data class Booking(
    var tripId: String = "",
    var bookingCost: String = "",
    var email: String = "",
    var phoneNumber: String = "",
    var selectedSeats: List<String> = emptyList(),
    var passengerDetails: List<String> = emptyList(),
    var transactionScreenshot: String? = null, // Path or URL to screenshot
    val bookingTime: String = Utils.currentTime()
)

data class PassengerDetail(
    val seatNo: String,
    val name: String,
    val age: Int,
    val gender: String
)

@Serializable
data class Trip(
    var id: String = "",
    val tripName: String = "",
    val departureLocation: String = "",
    val departureDate: String = "",
    val departureTime: String = "",
    val arrivalLocation: String = "",
    val arrivalDate: String = "",
    val arrivalTime: String = "",
    val costPerSeat: String = "",
    val coachCategory: String = "",
    var coachType: String = "",
    val totalSeats: Int = 0,
    var availableSeats: Int = 0,
    var busLayout: BusLayout? = null,
    val bannerUri: String? = null,
    var selectedSeats: List<String> = emptyList(),
    var organizer: AppUser = AppUser("","","","","")
)

@Serializable
data class BusLayout(
    val leftRow: Int = 2,
    val rightRow: Int = 3,
    val backRow: Int = 0
)

@Serializable
data class AppUser(
    var email: String = "",
    var name: String = "",
    var phoneNumber: String = "",
    var profile: String = "",
    var uid: String = ""
)